import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { isPublicForm } from 'apps/web_forms/api/api';
import DMButton from 'apps/web_forms/components/commons/DMButton';
import FormPageHeader from 'apps/web_forms/components/FormPageHeader';
import {
  setModal,
  resetModal,
  setSuccessfulAction,
} from 'apps/web_forms/slices/appSlice';
import { HIDE_DRAFTS, ModalTypes } from 'apps/web_forms/utils/constants';
import FormElements from './FormElements';
import { StyledFormControl } from './styles';
import useGlobalSelector, {
  selectIsSubmitting,
} from 'apps/web_forms/hooks/useGlobalSelector';

const Form = ({
  goBackUrl,
  selectedForm = {},
  loading,
  form,
  submit,
  showNotificationBar,
  cleanup,
}) => {
  const formContext = useFormContext();
  const isSubmitting = useSelector(selectIsSubmitting);
  const { resourcesLoading } = useGlobalSelector();

  const dispatch = useDispatch();

  const openDraftModal = () => {
    dispatch(
      setModal({
        type: ModalTypes.DRAFT_MODAL,
        extraProps: {
          saveDraft: (description) => {
            dispatch(setSuccessfulAction('saved'));
            submit('draft', description);
            dispatch(resetModal());
            cleanup();
          },
          setDraftModalOpen: () => {
            dispatch(resetModal());
          },
        },
      })
    );
  };

  return (
    !loading && !resourcesLoading && (
      <>
        <FormPageHeader
          sticky
          notificationBarShowing={showNotificationBar}
          title={selectedForm?.title}
          description={selectedForm.description}
          goBackUrl={goBackUrl}
          isSubmitting={isSubmitting}
          renderToggleButton={false}
          renderRightButton={() => (
            <DMButton disabled={isSubmitting} filled type='submit'>
              {'Submit'}
            </DMButton>
          )}
          renderSecondaryRightButton={
            !HIDE_DRAFTS && !isPublicForm()
              ? () => (
                  <DMButton
                    disabled={isSubmitting}
                    callbackMethod={() => openDraftModal()}
                  >
                    {'Save As Draft'}
                  </DMButton>
                )
              : null
          }
        />
        {form.inputList && (
          <StyledFormControl>
            <FormElements
              elements={form.inputList || []}
              getInput={form.getInput}
              dispatchInitialAnswers={form.dispatchInitialAnswers}
              formContext={formContext}
              formErrors={formContext.errors}
            />
          </StyledFormControl>
        )}
      </>
    )
  );
};

export default Form;
